import actionTypes from '../../actions/actionTypes';

const _initState = { 
  isLoading: false, 
  data: {
    children: []
  }
};

const menu = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_MENU_REQUEST:
      return {  data: { children: [] }, isLoading: true };

    case actionTypes.GET_MENU_SUCCESS:
      return { isLoading: false, data: action.res.Data }

    case actionTypes.GET_MENU_FAILURE:
      return _initState;
  
    default:
      return state
  }
};

export default menu;